import { HubCameraType } from '@robovision/hub'


export enum EmulatorCameraType {
  EMULATOR = 'EMULATOR',
}

export type CameraType = HubCameraType | EmulatorCameraType
